import React, { Component } from 'react';
import './projectwizard-base.scss';
import './App.css';
import { SelectButton } from './SelectButton';
import { Row, Col, Badge } from 'reactstrap';
import { mobile } from './question/mobile';
import { SelectFeauture } from './SelectFeauture';
import { SelectableButtons } from './SelectableButtons';
import Finish from './Finish';
import { translate } from 'react-jhipster';
import { QuestionControl } from './QuestionControl';

export default class ProjectWizardBase extends Component<any> {
  state = {
    control: 0,
    cevap: '',
    kontrol: 0,
    currentid: 0,
    currentidback: 0,
    IDs: [],
    feature: [],
    price: [{ currentid: -1, price: 0 }],
    last: {},
    questions: this.props.questions,
  };

  savedData = {};

  constructor(props) {
    super(props);

    this.idPlusOK = this.idPlusOK.bind(this);
    this.idPlusPositive = this.idPlusPositive.bind(this);
    this.idPlusNegative = this.idPlusNegative.bind(this);
    this.turnBackbutton = this.turnBackbutton.bind(this);
    this.addprice = this.addprice.bind(this);
    this.addpriceFeature = this.addpriceFeature.bind(this);
    this.finishHandler = this.finishHandler.bind(this);

    this.setFlow = this.setFlow.bind(this);
  }

  setFlow(flowid) {
    const id = Object.keys(this.state.questions).indexOf(flowid) + 1;

    this.setState({
      currentid: id,
    });
  }

  addprice(pricex) {
    if (this.state.price.filter(element => element.currentid === this.state.currentid).length === 0) {
      const commentData = { currentid: this.state.currentid, price: pricex };

      this.state.price.push(commentData);

      console.warn(this.state.price, this.savedData);
    }
  }

  addpriceFeature(data) {
    const sum = data.map(element => element.price).reduce((a, b) => a + b, 0);
    const commentData = {
      currentid: this.state.currentid,
      price: sum,
      feature: Array.from(
        new Set(
          data.map(element => {
            return { element: element.element, price: element.price, duration: element.duration };
          })
        )
      ),
    };
    this.setState({
      price: this.state.price.filter(element => element.currentid !== this.state.currentid).concat(commentData),
    });
    //  this.state.price.push(  commentData);

    console.warn('addpriceFeature', this.state.price);
  }

  idPlusOK(e) {
    //  if (this.state.currentid>=0)
    {
      this.setState({
        currentid: this.state.questions[this.state.currentid].selectOK,
      });
      this.state.IDs.push(this.state.currentid);
      // this.state.price [this.state.currentid]=0;

      this.addprice(0);
    }
  }

  idPlusPositive(e) {
    this.setState({
      currentid: this.state.questions[this.state.currentid].selectPositive,
    });
    this.state.IDs.push(this.state.currentid);
    // if (Object.prototype.hasOwnProperty.call( (this.state.questions[this.state.currentid], "selectPositivePrice")) )
    // this.state.price.push(this.state.questions[this.state.currentid].selectPositivePrice)
    this.addprice(this.state.questions[this.state.currentid].selectPositivePrice);
  }

  idPlusNegative(e) {
    this.setState({
      currentid: this.state.questions[this.state.currentid].selectNegative,
    });
    this.state.IDs.push(this.state.currentid);
    //  if (Object.prototype.hasOwnProperty.call( (this.state.questions[this.state.currentid], "selectNegativePrice")))

    //                this.state.price.push(this.state.questions[this.state.currentid].selectNegativePrice)
    this.addprice(this.state.questions[this.state.currentid].selectNegativePrice);
  }

  turnBackbutton(e) {
    this.setState({
      last: this.state.price.filter(element => element.currentid === this.state.IDs[this.state.IDs.length - 1]),
    });

    this.setState({
      currentid: this.state.IDs[this.state.IDs.length - 1],
    });
    this.state.price.splice(-1, 1);

    this.state.IDs.splice(-1, 1);
    console.warn(this.state.price, this.state.last);
  }
  addHandler(e) {}
  finishHandler(e) {
    this.props.finishEvent(this.state.price);
  }

  finish() {
    return !(this.state.currentid === this.state.IDs[this.state.IDs.length - 1]);
  }

  handleData(event) {
    //console.log(event);
    //  this.state.answer[  event.target.id] = event.target.value;
    this.savedData[event.target.id] = event.target.value;
  }

  handleDataGet(name) {
    return name in this.savedData ? this.savedData[name] : '';
  }

  render() {
    const totalPrice = this.state.price.map(e => e.price).reduce((a, b) => a + b, 0);
    const currentQuestion = this.state.questions[this.state.currentid];

    return (
      <div className="wizard-container">
        {/* HEADER */}
        <div className="wizard-header">
          <span className="wizard-price">
            {translate('project.wizard.totalprice')} : {totalPrice}
          </span>

          <div className="wizard-steps">
            {Object.keys(this.state.questions).map(step => (
              <span key={step} className={`wizard-step ${Number(this.state.currentid) === Number(step) ? 'active' : ''}`}>
                {step}
              </span>
            ))}
          </div>
        </div>

        {/* CONTENT */}
        <div className="wizard-card">
          <Row className="align-items-center">
            {/* IMAGE */}
            <Col md="5" className="wizard-image">
              {currentQuestion.img ? (
                <img src={`content/images/project${currentQuestion.img}`} alt="step" />
              ) : (
                <div className="wizard-image-placeholder" />
              )}
            </Col>

            {/* CONTROLS */}
            <Col md="7" className="wizard-controls">
              {currentQuestion.selectListData && (
                <SelectFeauture
                  addHandler={this.addHandler}
                  selectListData={currentQuestion.selectListData}
                  addFeature={this.addpriceFeature}
                  setFeature={this.state.last}
                />
              )}

              {currentQuestion.selectItem && (
                <SelectableButtons addHandler={this.addHandler} selectItem={currentQuestion.selectItem} setFlow={this.setFlow} />
              )}

              {currentQuestion.controls && (
                <QuestionControl
                  buttons={currentQuestion.controls}
                  handleData={this.handleData}
                  handleDataGet={this.handleDataGet}
                  savedData={this.savedData}
                />
              )}
            </Col>
          </Row>
        </div>

        {/* DESCRIPTION */}
        <div className="wizard-description">{translate('project.wizard.' + currentQuestion.datalang)}</div>

        {/* FOOTER ACTIONS */}
        <div className="wizard-footer">
          <SelectButton
            showBack={this.state.IDs.length > 0}
            showOk={!currentQuestion.selectable}
            selectable={currentQuestion.selectable}
            finish={this.finish()}
            handleClickNo={this.idPlusNegative}
            handleClickYes={this.idPlusPositive}
            handleClickOk={this.idPlusOK}
            handleClickBack={this.turnBackbutton}
          />

          {!this.finish() && (
            <Finish
              selectedFeature={this.state.price}
              allFeature={this.state.questions}
              finishEvent={this.finishHandler}
              handleClickBack={this.turnBackbutton}
            />
          )}
        </div>
      </div>
    );
  }
}
